import * as React from 'react';
import LocalDiv from '../../../localization/LocalDiv';
import { FLEX_ROW, FLEX_ADAPTIVE, FLEX_COLUMN } from '../../../layout/flexBox';
import Msg from '../../../localization/Msg';
import { Str } from '../../../localization/translationKeys';
import { css } from '@emotion/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { Requirement } from '../../models';
import { COLORS } from '../../../globalStyle/colors';
import RequirementMenuItem from '../../requirements/RequirementMenuItem';
import { btnStyle } from '../../../forms/styles/button';


const styles = {
  root:          [
    FLEX_COLUMN,
    css`
      margin: 18px 0;
      align-items: stretch;
      color: ${COLORS.DARK_GREY};
    `,
  ],
  padded20Px:    css`
    padding: 20px;
  `,
  title:         [
    FLEX_ROW,
    css`
      justify-content: space-between;
      background-color: ${COLORS.MENU_GREY};
      color: ${COLORS.WHITE};
      font-size: 12px;
    `,
  ],
  reqsContainer: [
    FLEX_ADAPTIVE,
    css`
      background-color: ${COLORS.LIGHT_GREY};
    `,
  ],
  reqItem:       FLEX_ROW,
  completed:     css`
    color: ${COLORS.BLUE};
  `,
};


type Props = {
  minimumsRequired: boolean;
  maximumsRequired: boolean;

  isOpen?: boolean;
  toggleOpen: () => void;

  requirements: Requirement[];

  className?: string;
};


/**
 * RequirementMobileMenu: a component that displays text descriptions of project requirements via an animated dropdown
 * menu
 *
 * PureComponent: true
 * Redux Connected: false
 */
const RequirementMobileMenu: React.FC<Props> = props => (
  <LocalDiv css={styles.root} className={props.className}>
    <button css={btnStyle.invisible} onClick={props.toggleOpen}>
      <LocalDiv css={[styles.title, styles.padded20Px]}>
        <Msg str={props.minimumsRequired ? Str.InviteRequirements : Str.RecommendedMinimums} />
        <FontAwesomeIcon icon={props.isOpen ? faChevronUp : faChevronDown} />
      </LocalDiv>
    </button>
    {
      props.isOpen && (
        props.requirements.map(
          requirement => (
            <RequirementMenuItem
              css={styles.reqItem}
              key={requirement.fullName}
              title={`${requirement.completedCount}/${requirement.minimumRequired}`}
              requirement={requirement}
              showMaximum={props.maximumsRequired}
            />
          ),
        )
      )
    }
  </LocalDiv>
);

export default RequirementMobileMenu;
